const WS_SERVER = process.env.WS_SERVER || "wss://events.lotopix.net";

export { WS_SERVER };
